import { Box, Typography } from '@mui/material';
import RegistrationCodes from './RegistrationCodes';
import { WithPermission } from '../../Auth/WithPermission';
import RegisteredDevices from './RegisteredDevices';

const ManageDevices = () => {
  return (
    <Box p={4}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
            Manage Devices
        </Typography>

        <WithPermission rolesRequired={['admin', 'superadmin']}>
            <RegistrationCodes/>
        </WithPermission>

        <RegisteredDevices/>

    </Box>
  );
};

export default ManageDevices;